import animation from "assets/icons/loading.svg";
export function Loading({ loadingAnimation }) {
  return (
    <div className="flex-col text-white text-xl flex justify-center items-center h-[100dvh] bg-opacity-50">
      <img src={loadingAnimation || animation} alt="loading" className="w-28" />
      <p>Loading...</p>
    </div>
  );
}
